export default __webpack_public_path__ + "static/media/44.392471d4.png";